import React,{ useState, useEffect } from "react";
import axios from 'axios';

import { 
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

import ChannelListingTable from './ChannelListingTable';

function TVChannelListing() {
    const [channelsLoading, setChannelsLoading] = useState( false );
    const [channelObjects, setChannelObjects] = useState( [] );
    const siteDomain = headerVars.siteDomain;

    useEffect(() => {
        handleShowChannelListing();
    },[]);

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let isValid = validateDestination( currentVal );
        let validationSuffix = <></>;

        validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

        let theNumber = isValid ? currentVal : '';

        setPhoneNumberValid( isValid );
        setPhoneNumber( theNumber );
        setPhoneNumberValidSuffix( validationSuffix );
    }

    const handleShowChannelListing = () => {
        setChannelsLoading( true );
        let channelData = null;
        let searchVal = ''
        let requestUrl = siteDomain+"/wp-json/wp/v2/tv-channels/channel-listing?search="+searchVal;

        axios
        .get( requestUrl )
        .then(function(response){
            setChannelsLoading( false );
            channelData = JSON.parse(response.data);
            //console.log( "channelData", channelData );
            let channels = modelDataFromResponse( channelData );
            //console.log( "channels", channels );
            setChannelObjects( channels );
        })
        .catch(function (error) {
            console.log(error);
            setChannelsLoading( false );
        })
        .finally(function () {
            // always executed 
        });
    }

    const modelDataFromResponse = ( response ) => {
        var channels = [];
        
        for( var i=0; i< response.length; i++ ) {
            var channel = {};
            var title = (response[i].title != null) ? response[i].title : "";
            var content = (response[i].content != null) ? response[i].content : "";
            var logo = (response[i].logo != null) ? response[i].logo : "";
            var channel = (response[i].metadata['_startcf_tv-channel-number'] != null) ? response[i].metadata['_startcf_tv-channel-number'][0] : "";
            var light = (response[i].metadata['_startcf_tv-channel-light'] != null) ? response[i].metadata['_startcf_tv-channel-light'][0] : "";
            var premium = (response[i].metadata['_startcf_tv-channel-premium'] != null) ? response[i].metadata['_startcf_tv-channel-premium'][0] : "";
            var ultimate = (response[i].metadata['_startcf_tv-channel-ultimate'] != null) ? response[i].metadata['_startcf_tv-channel-ultimate'][0] : "";
            var themes = "";
            var resolution = (response[i].metadata['_startcf_tv-channel-resolution'] != null) ? response[i].metadata['_startcf_tv-channel-resolution'][0] : "";
            var wifi = (response[i].metadata['_startcf_tv-channel-wifi'] != null) ? response[i].metadata['_startcf_tv-channel-wifi'][0] : "";
            var pause = (response[i].metadata['_startcf_tv-channel-pause'] != null) ? response[i].metadata['_startcf_tv-channel-pause'][0] : "";
            var restart = (response[i].metadata['_startcf_tv-channel-restart'] != null) ? response[i].metadata['_startcf_tv-channel-restart'][0] : "";
            var lookback = (response[i].metadata['_startcf_tv-channel-lookback'] != null) ? response[i].metadata['_startcf_tv-channel-lookback'][0] : "";
            var pvr = (response[i].metadata['_startcf_tv-channel-pvr'] != null) ? response[i].metadata['_startcf_tv-channel-pvr'][0] : "";

            if( response[i].channeltags.length && response[i].channeltags[0].name != 'light' && response[i].channeltags[0].name != 'premium' && response[i].channeltags[0].name != 'ultimate' ) {
                themes = "Available in the "+response[i].channeltags[0].name+ " theme pack.";
            }

            channel = {
                'title': title,
                'content': content,
                'logo': logo,
                'channel': channel,
                'light': light,
                'premium': premium,
                'ultimate': ultimate,
                'themes': themes,
                'resolution': resolution,
                'wifi': wifi,
                'pause': pause,
                'restart': restart,
                'channel': channel,
                'lookback': lookback,
                'pvr': pvr,
            };

            channels.push(channel);
        }

        return channels;
    }

    return (
        <div className="startca-react-channel-listing-container" style={{margin:"4rem 0"}}>
            <div className="channel-listing-modal-content-container">
                <h2 style={{ fontSize:"2rem" }}>Start TV Channel Lineup</h2>
                <p>Wondering what channels are included in each TV package? Keep reading to learn more.</p>
                <ChannelListingTable
                    channelObjects={ channelObjects }
                    channelsLoading={ channelsLoading }
                />
            </div>
        </div>
    )
}

export default TVChannelListing